import React, { useEffect, useRef, useState } from "react";
import { toAbsoluteUrl } from "../../helpers/Reusable";
import { IoArrowDown, IoArrowUp, IoClose } from "react-icons/io5";
import { ToastContainer } from "react-toastify";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { BsFullscreen } from "react-icons/bs";

const TaxReturns = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalNo, setModalNo] = useState("");
  const taxreturns = [
    {
      no: "01",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      title: "VAT Services",
      services: [
        {
          text: "First-time adoption / Registration",
        },
        {
          text: "Deregistration",
        },
        {
          text: "Return filing",
        },
        {
          text: "Advisory and Opinion",
        },
        {
          text: "Tax Audit",
        },
        {
          text: "Credit disputes",
        },
        {
          text: "VAT Automation",
        },
        {
          text: "VAT Supply Chain Management",
        },
      ],
    },
    {
      no: "02",
      title: "Corporate Tax Services",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      services: [
        {
          text: "First time adoption / Registration",
        },
        {
          text: "Tax compliance/ Impact Assessment",
        },
        {
          text: "Return filing",
        },
        {
          text: "Tax Advisory",
        },
        {
          text: "Tax Structuring",
        },
        {
          text: "Tax refund",
        },
        {
          text: "Transfer pricing",
        },
        {
          text: "Inbound Investment / Outbound Tax",
        },
      ],
    },
    {
      no: "03",
      title: "Excise Tax Services",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      services: [
        {
          text: "First time adoption / registration",
        },
        {
          text: "Deregistration",
        },
        {
          text: "Return filing",
        },
        {
          text: "Tax Audit",
        },
        {
          text: "Advisory and Opinion",
        },
        {
          text: "Disputes / Litigation Support",
        },
        {
          text: "Implementation/ Compliance",
        },
        {
          text: "Excise Impact Assessment",
        },
      ],
    },
    {
      no: "04",
      title: "Custom Duty compliance",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      services: [
        {
          text: "Registration/ License",
        },
        {
          text: "Set-up and implementation",
        },
        {
          text: "Advisory and Opinion",
        },
        {
          text: "Advisory and Opinion",
        },
        {
          text: "Custom Duty compliance",
        },
        {
          text: "Custom Duty Refund",
        },
        {
          text: "Duty exemptions",
        },
        {
          text: "Customs valuations",
        },
      ],
    },
    {
      no: "05",
      title: "Stamp Duty Services",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      services: [
        {
          text: "Stamp Duty assessments",
        },
        {
          text: "Stamp Duty law compliance",
        },
        {
          text: "Duty Payment disputes",
        },
        {
          text: "Stamp Duty exemptions",
        },
      ],
    },
    {
      no: "06",
      title: "International Tax Services",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      services: [
        {
          text: "Tax planning projections and calculations",
        },
        {
          text: "Acquisition structuring and restructurings",
        },
        {
          text: "Country By Country Reporting",
        },
        {
          text: "Tax Residency Certificate",
        },
        {
          text: "Tax Advisory",
        },
        {
          text: "Foreign tax credits",
        },
        {
          text: "DTAA",
        },
      ],
    },
    {
      no: "07",
      title: "Economic Substance Regulation",
      bgColorY: "#c99930",
      bgColorB: "#2c3451",
      services: [
        {
          text: "Country Preliminary Assessment",
        },
        {
          text: "Core Assessment",
        },
        {
          text: "Gap Analysis",
        },
        {
          text: "Appeals and Litigation",
        },
        {
          text: "Development of Corporate Governance",
        },
      ],
    },
  ];

  // Opem Modal Popup Form Function
  const openModal = (id) => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
    setModalNo(id);
  };
  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    setModalNo("");
  };

  const scrollRefs = useRef({}); // Stores refs dynamically per index
  const [isScrollable, setIsScrollable] = useState({});

  useEffect(() => {
    // Check if each ul is scrollable and update state
    const checkScrollability = () => {
      const newScrollableState = {};
      taxreturns.forEach((_, index) => {
        const element = scrollRefs.current[index];
        if (element) {
          newScrollableState[index] =
            element.scrollHeight > element.clientHeight;
        }
      });
      setIsScrollable(newScrollableState);
    };

    checkScrollability();
    window.addEventListener("resize", checkScrollability);

    return () => window.removeEventListener("resize", checkScrollability);
  }, [taxreturns]);

  // Function to scroll up
  const scrollUp = (index) => {
    if (scrollRefs.current[index]) {
      scrollRefs.current[index].scrollBy({ top: -50, behavior: "smooth" });
    }
  };

  // Function to scroll down (only last clicked is dynamic)
  const scrollDown = (index) => {
    // setLastClicked(index); // Set last clicked index
    if (scrollRefs.current[index]) {
      scrollRefs.current[index].scrollBy({ top: 50, behavior: "smooth" });
    }
  };

  return (
    <>
      {isModalOpen == true && (
        <>
          <div
            onClick={() => closeModal()}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            {taxreturns.map(
              (data) =>
                modalNo == data.no && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="w-[90%] md:w-[70%] lg:w-[50%] xl:w-[40%] xxl:container p-[2%] mx-auto my-[5%] top-[30%] md:my-[5%] lg:my-0 relative lg:top-[30%] xl:top-1/2 transform xl:-translate-y-1/2 form-box"
                  >
                    <div className="mb-[3%] flex items-center justify-between">
                      <h1 className="hanson">{data.title}</h1>
                      <IoClose
                        onClick={() => closeModal()}
                        className="w-[3rem] h-[3rem] cursor-pointer"
                      />
                    </div>
                    <div className="">
                      <div className="mb-[3rem]">
                        <ul className="pl-[3rem] form-ul-disc-g">
                          {data.services.map((data) => (
                            <li className="">{data.text}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
        </>
      )}
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Tax & returns
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div class="w-full grid md:grid-cols-2 xl:grid-cols-3 gap-y-[5rem] md:gap-y-[10rem] gap-x-[5rem] hexagon-grid">
            {taxreturns.map((data, index) => (
              <div className="flex items-center justify-center relative hexagon-container">
                <div
                  onClick={() => openModal(data.no)}
                  className={`w-[55px] h-[55px] lg:w-[70px] lg:h-[70px] text-[2.5rem] lg:text-[3rem] ml-[-23rem] lg:ml-[-25rem] top-[12%] lg:top-[10%] cursor-pointer flex items-center justify-center rounded-full ${
                    data.no % 2 == 0 ? "hexagon-number-y2" : ""
                  }  ${
                    data.no == "02" || data.no == "05"
                      ? `hexagon-number-y`
                      : `hexagon-number-b`
                  }`}
                >
                  {data.no}
                </div>
                <div
                  onClick={() => openModal(data.no)}
                  className={`w-[250px] h-[200px] lg:w-[300px] lg:h-[250px] cursor-pointer ml-[10rem] px-[10rem] py-[5rem] ${
                    data.no % 2 == 0 ? "hexagon-bg-y2" : ""
                  } ${
                    data.no == "02" || data.no == "05"
                      ? `hexagon-bg-y`
                      : "hexagon-bg-b"
                  }`}
                ></div>
                <div
                  // onClick={() => openModal(data.no)}
                  class="w-[300px] h-[250px] lg:w-[350px] lg:h-[300px] cursor-pointer px-[8.5rem] lg:px-[9.5rem] flex items-center hexagon"
                >
                  <div className="relative w-full h-[225px] lg:h-[275px] flex flex-col hexagon-text-box">
                    <h1
                      onClick={() => openModal(data.no)}
                      className="text-[1.8rem] mb-[1.5rem] lg:text-[2rem] htb-title outfit"
                    >
                      {data.title}
                    </h1>
                    <ul
                      onClick={() => openModal(data.no)}
                      className={`h-[225px] lg:h-[275px] overflow-y-auto overflow-x-hidden pl-[2rem] pr-[1rem] outfit  ${
                        data.no % 2 == 0 ? "htb-ul-g-y2" : ""
                      } ${
                        data.no == "02" || data.no == "05"
                          ? `htb-ul-g-y`
                          : "htb-ul-g"
                      }`}
                      style={{ scrollbarWidth: "none" }}
                      ref={(el) => (scrollRefs.current[index] = el)}
                    >
                      {data.services.map((data) => (
                        <li className="text-[1.4rem] lg:text-[1.6rem] htb-ul-g-li">
                          {data.text}
                        </li>
                      ))}
                    </ul>
                    <div
                      className={`absolute flex flex-col gap-[5rem] right-[-2rem] lg:right-[-2rem] top-[5rem] h-100 justify-center items-center ${
                        isScrollable[index] ? "lg:top-[8rem]" : "lg:top-[15rem]"
                      }`}
                    >
                      {isScrollable[index] && (
                        <IoArrowUp
                          className="relative text-gray-500 cursor-pointer"
                          size={20}
                          onClick={() => scrollUp(index)}
                        />
                      )}
                      <BsFullscreen
                        className="text-gray-500 cursor-pointer"
                        size={16}
                        onClick={() => openModal(data.no)}
                        // data-bs-toggle="tooltip"
                        // data-bs-placement="top"
                        // title="Full Screen"
                      />
                      {isScrollable[index] && (
                        <IoArrowDown
                          className="text-gray-500 cursor-pointer"
                          size={20}
                          onClick={() => scrollDown(index)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxReturns;
